var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1407_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11H13.4444C13.857 11 14.2527 10.8156 14.5444 10.4874C14.8361 10.1592 15 9.71413 15 9.25V5.75C15 5.28587 14.8361 4.84075 14.5444 4.51256C14.2527 4.18437 13.857 4 13.4444 4H2.55556C2.143 4 1.74733 4.18437 1.45561 4.51256C1.16389 4.84075 1 5.28587 1 5.75V9.25C1 9.71413 1.16389 10.1592 1.45561 10.4874C1.74733 10.8156 2.143 11 2.55556 11H4",
    stroke: "#2D2E2F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4V2C11 1.73478 10.8736 1.48043 10.6485 1.29289C10.4235 1.10536 10.1183 1 9.8 1H6.2C5.88174 1 5.57652 1.10536 5.35147 1.29289C5.12643 1.48043 5 1.73478 5 2V4",
    stroke: "#2D2E2F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 8H5.6C4.71634 8 4 8.7835 4 9.75V13.25C4 14.2165 4.71634 15 5.6 15H10.4C11.2837 15 12 14.2165 12 13.25V9.75C12 8.7835 11.2837 8 10.4 8Z",
    stroke: "#2D2E2F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1407_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a33697d8c2912a338bff8aac9d41df0d.svg";
export { ForwardRef as ReactComponent };